interface CircularProgressIndicatorProps {
  currentSteps: number;
  totalSteps: number;
  width?: number;
  height?: number;
  strokeWidth?: number;
  color?: string;
}

export const CircularProgressIndicator = ({
  currentSteps,
  totalSteps,
  width = 50,
  height = 50,
  strokeWidth = 6,
  color = '#47BA00',
}: CircularProgressIndicatorProps) => {
  const dashOffset = totalSteps > 0 ? 100 - (100 * currentSteps) / totalSteps : 100;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 50 50"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: 'rotate(-90deg)' }}
    >
      <circle
        r="15"
        cx="25"
        cy="25"
        fill="transparent"
        stroke="#00000014"
        strokeWidth={strokeWidth}
        strokeDasharray="100px"
        strokeDashoffset="0"
      />
      <circle
        r="15"
        cx="25"
        cy="25"
        fill="transparent"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="butt"
        strokeDashoffset={`${dashOffset}px`}
        strokeDasharray="100px"
      />
    </svg>
  );
};
